import { motion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: EASE, delay }}
            className="block will-change-transform"
        >
            {children}
        </motion.span>
    </span>
);

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.85, ease: EASE, delay }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <span
        className={`font-mono text-[11px] uppercase tracking-[0.3em] text-gold ${className}`}
    >
        {children}
    </span>
);
